import create from 'zustand'
import content from "../../content.js"
import { mountStoreDevtool } from 'simple-zustand-devtools';

function getSectionsOffsets(content){
    const { paragraphs } = content;
    const sectionsOffsets = new Array(paragraphs.length);

    for (let i = 0; i < paragraphs.length; i++) {
        const prev = paragraphs[i-1]
        const current = paragraphs[i];
        const offset = sectionsOffsets[i-1] ?? 0;

        if(!prev){
            sectionsOffsets[i] = 1;
            continue;
        }

        // prev is regular
        if(!prev.hugeText){
            if(current.hugeText){
                sectionsOffsets[i] = offset + 0.9;
                continue;
            }
            sectionsOffsets[i] = offset + 1; // current is regular
            continue;
        }

        // prev is hugeText
        if(current.hugeText){
            sectionsOffsets[i] = offset + 0.9;
            continue;
        }

        sectionsOffsets[i] = offset + 1.3; // current is regular
    }

    return sectionsOffsets;
}

const useContentStore = create((set) => ({
    current: "",
    language: "en",
    pagesOrder: content.order,
    pages: content,
    content: null,
    sectionsOffsets: [],
    setPage: (name) => set((state) => {
        const nextContent = content[name];
        nextContent.top.current = 0;
        document.getElementsByClassName("scrollArea")[0]?.scrollTo(0, 0)

        return {
            current: name,
            content: content[name],
            sectionsOffsets: getSectionsOffsets(content[name]),
        };
    }),
    setLanguage: (lg) => set((state) => {
        return {
            language: lg,
        };
    }),
}))

// mountStoreDevtool('Store', useContentStore);

export default useContentStore;
